import React from 'react';
import ReactDOM from 'react-dom';
import Root from './Root';
import configureStore from './redux/configureStore';
import rootReducer from './redux';

const store = configureStore(rootReducer);

ReactDOM.render(<Root store={store} />, document.getElementById('root'));
